const types = [
  {
    label: 'Данные не верны',
    value: 'wrong_report_data',
  },
  {
    label: 'Отчет устарел',
    value: 'outdated_report_data',
  },
  {
    label: 'VIN не соответствует ТС',
    value: 'vin_does_not_match_transport',
  },
];

export default types;
